import { stringifyGraph } from '@/clients/http'
import { AttributeModel as AttributeApi } from '@/http/models/attribute/Attribute'

import { UseFetchListForm, useFetchList } from '@/hooks/useFetchList'

import { AttributeHttpParams, AttributeModel } from '@/types'

export interface AttributeListFilters {
  search?: string
  status?: 'active' | 'inactive' | null
}

export interface AttributeListForm extends UseFetchListForm<
  AttributeListFilters,
  AttributeModel.Attribute
> {}

interface UseFetchAttributesProps {
  sort?: string | null
  shouldFetchList?: boolean
}

export const attributeInitialFilters: AttributeListFilters = {
  search: '',
  status: null,
}

export const useFetchAttributes = ({ sort, shouldFetchList }: UseFetchAttributesProps) => {
  return useFetchList<
    AttributeListFilters,
    AttributeModel.Attribute,
    {},
    any,
    typeof AttributeApi.getList
  >({
    pageSize: 10,
    initialFilters: attributeInitialFilters,
    fetchFunction: AttributeApi.getList,
    sort,
    register: shouldFetchList,
    buildQueryParams: (filters): Partial<AttributeHttpParams.GetList['query']> => ({
      search: filters.search || undefined,
      status: filters.status || undefined,
      graph_enc: stringifyGraph({
        '*': true,
        values: {
          '*': true,
        },
        'products.count': true,
      }),
    }),
    buildParams: () => ({}),
  })
}
